const LITIGII_TABS = {
  GESTIONARE: 'gestionare',
  NOTIFICARI: 'notificari'
};

const menuEntries = [
  { key: 'gestionare', name: 'Gestionare' },
  { key: 'notificari', name: 'Notificari' }
];

export { menuEntries, LITIGII_TABS };
